import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';

import { FloatFilter, FloatTags, getFloatApiParam } from './Float';


export const LevelValue = React.memo((props) => {
  const {
    l,
    
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : (value + '-й');
});

export const LevelFilter = FloatFilter;

export const LevelTags = FloatTags;

export const getLevelApiParam = getFloatApiParam;

export const getLevelExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value;
};
